export default __webpack_public_path__ + "media/images/front/municipality_collaboration/tenri/ogp-47afdf7ab6bcaee4bd770820801a8972.jpg";